import type { LicenceRuntime } from '@infra/licence/LicenceRuntime';

export class LicenceLimitsService {
  static canAddSalarie(
    runtime: LicenceRuntime | null,
    currentCount: number,
  ): {
    allowed: boolean;
    message?: string;
  } {
    const claims = runtime?.getState()?.claims;
    if (!claims) return { allowed: true };
    if (claims.max_salaries <= 0) return { allowed: true };
    if (currentCount >= claims.max_salaries) {
      return {
        allowed: false,
        message: `Limite de salariés atteinte (${claims.max_salaries} maximum). Contactez Nexxus pour étendre votre licence.`,
      };
    }
    return { allowed: true };
  }

  static canAddUser(
    runtime: LicenceRuntime | null,
    currentCount: number,
  ): {
    allowed: boolean;
    message?: string;
  } {
    const claims = runtime?.getState()?.claims;
    if (!claims) return { allowed: true };
    if (claims.max_users <= 0) return { allowed: true };
    if (currentCount >= claims.max_users) {
      return {
        allowed: false,
        message: `Limite d'utilisateurs atteinte (${claims.max_users} maximum).`,
      };
    }
    return { allowed: true };
  }
}
